import React from 'react';
export default function GraphemeText({ grapheme }) {
    let graphemeFontSize = "0.75em"
    const boxWrapper = document.querySelector(".grapheme-box");
    if (boxWrapper) {
        const boxWrapperWidth = boxWrapper.offsetWidth;
        graphemeFontSize = `${boxWrapperWidth * 0.4}px`;
    }

    return <p className="grapheme" style={{ fontSize: graphemeFontSize }}>{grapheme}</p>
}